export const API_BASE_URL =
  process.env.REACT_APP_BASE_URL || "https://losode.dev/api/v2/";

export const CLOUDINARY_URL =
  process.env.REACT_APP_CLOUDINARY_URL ||
  "https://api.cloudinary.com/v1_1/losode-ng/image/upload";

export const CLOUDINARY_API_KEY =
  process.env.REACT_APP_CLOUDINARY_API_KEY || "693411225724272";

export const CLOUDINARY_CLOUD_NAME =
  process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "losode-ng";

export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  "AIzaSyBqGKL75wmtYE2CZ4nT9TqMVqVuzApo_gI";
